import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

import { I18nService, TranslatePipe } from '@recruitee/i18n';

import { IconName } from '../../../icons-container/icons.type';
import { BadgeComponent } from '../../badge/badge.component';
import { CircularProgressIndicatorComponent } from '../../circular-progress-indicator/circular-progress-indicator.component';
import { IconColorDirective } from '../../icon/directives/icon-color.directive';
import { IconComponent } from '../../icon/icon.component';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { RtTooltip } from '../../tooltip/tooltip.directive';

export type segmentedButtonType<T> = {
  isActive: boolean;
  isAvailable: boolean;
  isDisabled?: boolean;
  value: T;
  label?: string | undefined;
  counter?: number | undefined | null;
  iconName?: IconName | undefined;
};

export type LanguageSwitcherItem = {
  code: string;
  name: string;
  primary: boolean;
  translationFieldsCount: number;
};

@Component({
  selector: 'rt-segmented-control-button',
  templateUrl: './segmented-control-button.component.html',
  styleUrls: ['./segmented-control-button.component.less'],
  host: {
    '[class.active-btn]': 'isActive',
    '[class.disabled]': 'isDisabled',
    '[class.full-width]': 'fullwidth',
  },
  standalone: true,
  imports: [
    BadgeComponent,
    CircularProgressIndicatorComponent,
    IconColorDirective,
    IconComponent,
    NgIf,
    RtTooltip,
    SpinnerComponent,
    TranslatePipe,
  ],
})
export class SegmentedControlButtonComponent {
  @Input() public type: 'view-switcher' | 'multilang-switcher';
  @Input() public fullwidth: boolean;
  @Input() public isActive: boolean;
  @Input() public isAvailable: boolean;
  @Input() public label: string | undefined;
  @Input() public counter: number | undefined | null;
  @Input() public iconName: IconName | undefined;
  @Input() public isDisabled: boolean | undefined;
  @Input() public language: LanguageSwitcherItem;
  @Input() public primaryLanguageLabel = 'app.common.default';
  @Input() public fieldsCount: number;
  @Input() public loadingLanguageCode: string | null = null;

  constructor(private i18n: I18nService) {}

  public getTranslationProgress(translationFieldsCount: number): number {
    return this.fieldsCount ? (translationFieldsCount / this.fieldsCount) * 100 : 0;
  }

  public getTooltipMessage(langTermsCount: number): string {
    return `${langTermsCount} / ${this.fieldsCount} ${this.i18n.translate(
      'app.languages.fields_translated',
    )}`;
  }
}
